export const UPDATE_BEDROOMS = "CLEANING_UPDATE_BEDROOMS";
export const UPDATE_BATHROOMS = "CLEANING_UPDATE_BATHROOMS";
export const UPDATE_FREQUENCY = "CLEANING_UPDATE_FREQUENCY";
export const TOGGLE_ADDON = "CLEANING_TOGGLE_ADDON";
export const UPDATE_DATE = "CLEANING_UPDATE_DATE";
export const UPDATE_TIME = "CLEANING_UPDATE_TIME";
export const CLEANING_SUCCESS = "CLEANING_SUCCESS";
export const CLEANING_SELECT = "CLEANING_SELECT";



// WEBPACK FOOTER //
// ./src/types/CleaningTypes.js